module.exports = __webpack_public_path__ + "img/document_p.95eda56b.svg";